<template>
  <v-menu :close-on-content-click="false" :nudge-width="100" offset-x>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        icon
        v-bind="attrs"
        v-on="on"
        style="box-shadow: none"
        class="text-none"
        v-if="autorizacoesDados.length > 0"
        :content="autorizacoesDados.length"
        color="error"
      >
        <v-badge
          v-if="autorizacoesDados.length > 0"
          :content="autorizacoesDados.length"
          color="error"
        >
          <v-icon> fa fa-unlock-alt </v-icon>
        </v-badge>
      </v-btn>
      <v-btn v-else icon v-bind="attrs" v-on="on" style="box-shadow: none" class="text-none">
        <v-icon aria-hidden="true">fa fa-bell</v-icon>
      </v-btn>
    </template>

    <v-card
      @click="pushAutorizacoes()"
      v-if="autorizacoesDados.length > 0"
      class="mx-auto"
      max-width="430"
    >
      <v-list>
        <v-list-item v-for="(autorizacao, i) of autorizacoesDados" :key="i">
          <v-list-item-avatar color="green">
            <v-list-item-title style="color: #fff"></v-list-item-title>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title> Pedido de Autorização</v-list-item-title>
            <v-list-item-subtitle>Tipo: {{ autorizacao.pedido.descricao }}</v-list-item-subtitle>
            <v-list-item-subtitle
              >Solicitado por: {{ autorizacao.solicitante.name }}</v-list-item-subtitle
            >
            <v-list-item-subtitle
              >Direcionado para: {{ autorizacao.aprovador.name }}</v-list-item-subtitle
            >
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card>
    <v-card v-else>
      <v-card-section class="pa-5">Não Existe nenhuma solicitação pendente.</v-card-section>
    </v-card>
  </v-menu>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import store from "../../store";

export default {
  name: "ENotificacoesList",
  data() {
    return {
      qtdPedidosPendentes: 0,
      autorizacoesDados: [],
      currentUser: store.getters["Auth/user"],
    };
  },
  mounted() {
    this.loadAutorizacoes();
  },
  methods: {
    async loadAutorizacoes() {
      if (this.currentUser.roles.filter((d) => d.name === "professor").length) {
        this.autorizacoes = await this.$services.autorizacoesService.syncAll("solicitante");
      } else {
        this.autorizacoes = await this.$services.autorizacoesService.syncAll("aprovador");
      }

      this.autorizacoesDados = this.autorizacoes.filter((a) => a.status === "PENDENTE");
    },
    pushAutorizacoes() {
      this.$router.push({ name: "autorizacoes" });
    },
  },
};
</script>
